module.exports = __webpack_public_path__ + "static/yeonji_v-ebe23a03dc5f9fc4d3534dd05ff947b0.jpg";